import { Injectable } from '@angular/core'
import { Actions, Effect } from '@ngrx/effects'
import { Action, select, Store } from '@ngrx/store'

import { Observable, of } from 'rxjs'
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators'
import { withPredicateFrom } from '../../core/helpers/rx-pipes'

import { OrderService } from '../services/orders.service'

import * as meta from '../actions/meta'
import * as order from '../actions/orders'

import * as fromOrders from '../reducers'
import * as fromAuth from '../../auth/reducers'

@Injectable()
export class OrderEffects {
    constructor(
        private actions$: Actions,
        private store: Store<fromOrders.State>,
        private orderSvc: OrderService
    ) { }

    @Effect()
    initCompleted$: Observable<Action> =
        this.actions$.ofType<Action>(meta.INIT_SUCCESS, meta.INIT_SKIPPED)
            .pipe(map(action => new order.Load()))

    @Effect()
    loadOrders$: Observable<Action> =
        this.actions$.ofType<order.Load>(order.LOAD)
            .pipe(
                withLatestFrom(
                    this.store.pipe(select(fromOrders.getAppliedFacets)),
                    this.store.pipe(select(fromAuth.getCustomerId)),
                    (action, applied, customerId) => ({applied, customerId})
                ),
                switchMap(data =>
                    this.orderSvc.getOrders(data.customerId, data.applied)
                        .pipe(
                            map(lines => new order.LoadSuccess(lines)),
                            catchError(e => of(new order.LoadFailed(e)))
                        )
                )
            )

    @Effect()
    expandOrderlines$: Observable<Action> =
        this.actions$.ofType<order.Expand>(order.EXPAND)
            .pipe(
                withPredicateFrom(this.store.pipe(select(fromOrders.canExpand))),
                withLatestFrom(
                    this.store.pipe(select(fromOrders.getCombinedExpandState)),
                    this.store.pipe(select(fromOrders.getNextPageNumber)),
                    this.store.pipe(select(fromAuth.getCustomerId)),
                    (action, state, nextPage, customerId) => ({ state, nextPage, customerId })
                ),
                switchMap(data =>
                    this.orderSvc.getOrders(data.customerId, data.state.facets, data.nextPage)
                        .pipe(
                            map(lines => new order.ExpandSuccess(lines)),
                            catchError(e => of(new order.ExpandFailed(e)))
                        )
                )
            )
}
